import styled from 'styled-components'

export const Title = styled.div`
	width: 100%;
	heigth: 100%;
  border-radius: 30px;
	background-color: ${(props) => props.backgroundColor};
  & h1{
    text-align: center;
  }


`
